import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';

const SEGMENTI = [
  { label: 'Trasporto', color: '#EB1C24', href: '/trasporto' },
  { label: 'Alloggio', color: '#0071BA', href: '/alloggio' },
  { label: 'Attività', color: '#FF5B00', href: '/attivita' },
  { label: 'Servizi', color: '#009045', href: '/servizi' },
];

/**
 * Header unico del sito. bg = colore di sfondo (per pagine segmento/dark);
 * light = varianti a sfondo chiaro (testo/icone scure, logo colorato).
 */
export default function Header({ bg = '#0a1628', light = false }) {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [menuDropdown, setMenuDropdown] = useState(false);
  const [menuAperto, setMenuAperto] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => setUser(session?.user ?? null));
    const { data: listener } = supabase.auth.onAuthStateChange((_evt, session) => setUser(session?.user ?? null));
    return () => listener.subscription.unsubscribe();
  }, []);

  const handleLogout = async () => {
    await supabase.auth.signOut();
    setMenuDropdown(false);
    setMenuAperto(false);
    navigate('/');
  };

  const textColor = light ? '#1a1a2e' : '#ffffff';
  const logoSrc = light ? '/images/logo.png' : '/images/logo_bianco.png';
  const iconFilter = light ? 'none' : 'brightness(0) invert(1)';
  const borderColor = light ? '#e5e7eb' : 'rgba(255,255,255,0.5)';

  const voci = [
    { label: 'Crea esperienza', href: '/crea' },
    { label: 'Come funziona', href: '/come-funziona' },
    ...(user ? [{ label: 'Dashboard', href: '/dashboard' }] : []),
  ];

  return (
    <>
      <style>{`
        .octa-hdr-link { display: flex; }
        .octa-hdr-burger { display: none; }
        @media (max-width: 640px) {
          .octa-hdr-link { display: none !important; }
          .octa-hdr-burger { display: flex !important; }
        }
      `}</style>

      <header className="octa-hdr" style={{ backgroundColor: bg, padding: '14px 40px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px', position: 'sticky', top: 0, zIndex: 200, borderBottom: light ? `1px solid ${borderColor}` : 'none' }}>
        <a href="/" style={{ display: 'flex', alignItems: 'center' }}>
          <img src={logoSrc} alt="OCTA" style={{ height: '32px', objectFit: 'contain' }} />
        </a>

        <nav style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
          <a href="/bacheca" className="octa-hdr-link" style={{ alignItems: 'center', color: textColor, fontSize: '14px', fontWeight: 600, textDecoration: 'none', fontFamily: 'Roboto, sans-serif' }}>
            Vetrina
          </a>

          <div className="octa-hdr-link" style={{ position: 'relative', alignItems: 'center' }} ref={dropdownRef}>
            <button onClick={() => setMenuDropdown(v => !v)} style={{ background: 'none', border: 'none', color: textColor, fontSize: '14px', fontWeight: 600, cursor: 'pointer', fontFamily: 'Roboto, sans-serif', display: 'flex', alignItems: 'center', gap: '4px', padding: 0 }}>
              Menu <span style={{ fontSize: '9px', opacity: 0.7 }}>{menuDropdown ? '▲' : '▼'}</span>
            </button>
            {menuDropdown && (
              <>
                <div onClick={() => setMenuDropdown(false)} style={{ position: 'fixed', inset: 0, zIndex: 199 }} />
                <div style={{ position: 'absolute', top: 'calc(100% + 10px)', right: 0, backgroundColor: '#0a1628', border: '1px solid rgba(255,255,255,0.12)', borderRadius: '12px', padding: '6px', minWidth: '196px', zIndex: 200, boxShadow: '0 8px 32px rgba(0,0,0,0.5)' }}>
                  {voci.map(v => (
                    <a key={v.href} href={v.href} onClick={() => setMenuDropdown(false)} style={{ display: 'block', padding: '9px 14px', borderRadius: '8px', color: '#ffffff', fontSize: '14px', fontWeight: 600, textDecoration: 'none' }}>
                      {v.label}
                    </a>
                  ))}
                  <div style={{ height: '1px', backgroundColor: 'rgba(255,255,255,0.12)', margin: '6px 4px' }} />
                  {SEGMENTI.map(s => (
                    <a key={s.href} href={s.href} onClick={() => setMenuDropdown(false)} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '9px 14px', borderRadius: '8px', color: '#ffffff', fontSize: '14px', fontWeight: 600, textDecoration: 'none' }}>
                      <span style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: s.color, flexShrink: 0 }} />
                      {s.label}
                    </a>
                  ))}
                  {user && (
                    <>
                      <div style={{ height: '1px', backgroundColor: 'rgba(255,255,255,0.12)', margin: '6px 4px' }} />
                      <button onClick={handleLogout} style={{ display: 'block', width: '100%', textAlign: 'left', padding: '9px 14px', borderRadius: '8px', color: 'rgba(255,255,255,0.7)', fontSize: '14px', fontWeight: 600, background: 'none', border: 'none', cursor: 'pointer', fontFamily: 'Roboto, sans-serif' }}>
                        Esci
                      </button>
                    </>
                  )}
                </div>
              </>
            )}
          </div>

          <a href={user ? '/profilo' : '/login'} className="octa-hdr-link" title={user ? 'Il mio profilo' : 'Accedi'} style={{ alignItems: 'center' }}>
            <img src="/images/profilo.svg" alt={user ? 'Il mio profilo' : 'Accedi'} style={{ height: '22px', filter: iconFilter }} />
          </a>
          <a href="/impostazioni" className="octa-hdr-link" title="Impostazioni" style={{ alignItems: 'center' }}>
            <img src="/images/impostazioni.svg" alt="Impostazioni" style={{ height: '22px', filter: iconFilter }} />
          </a>

          <button className="octa-hdr-burger" onClick={() => setMenuAperto(true)} style={{ background: 'none', border: 'none', color: textColor, fontSize: '26px', cursor: 'pointer', padding: '4px', lineHeight: 1, alignItems: 'center' }}>
            ☰
          </button>
        </nav>
      </header>

      {menuAperto && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 300, backgroundColor: '#0a1628', display: 'flex', flexDirection: 'column', padding: '24px', overflowY: 'auto' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '36px' }}>
            <a href="/"><img src="/images/logo_bianco.png" alt="OCTA" style={{ height: '32px' }} /></a>
            <button onClick={() => setMenuAperto(false)} style={{ background: 'none', border: 'none', color: '#ffffff', fontSize: '30px', cursor: 'pointer', lineHeight: 1 }}>✕</button>
          </div>
          <nav style={{ display: 'flex', flexDirection: 'column', gap: '24px', width: '100%', textAlign: 'center' }}>
            <a href="/bacheca" style={{ color: '#ffffff', fontSize: '20px', fontWeight: 700, textDecoration: 'none' }}>Vetrina</a>
            {voci.map(v => (
              <a key={v.href} href={v.href} style={{ color: '#ffffff', fontSize: '20px', fontWeight: 600, textDecoration: 'none' }}>{v.label}</a>
            ))}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <span style={{ color: '#ffffff', fontSize: '20px', fontWeight: 600 }}>Segmenti</span>
              {SEGMENTI.map(s => (
                <a key={s.href} href={s.href} style={{ color: 'rgba(255,255,255,0.8)', fontSize: '17px', textDecoration: 'none' }}>{s.label}</a>
              ))}
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '36px', marginTop: '4px' }}>
              <a href={user ? '/profilo' : '/login'} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '6px', color: '#ffffff', textDecoration: 'none' }}>
                <img src="/images/profilo.svg" alt="" style={{ height: '26px', filter: 'brightness(0) invert(1)' }} />
                <span style={{ fontSize: '13px' }}>{user ? 'Profilo' : 'Accedi'}</span>
              </a>
              <a href="/impostazioni" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '6px', color: '#ffffff', textDecoration: 'none' }}>
                <img src="/images/impostazioni.svg" alt="" style={{ height: '26px', filter: 'brightness(0) invert(1)' }} />
                <span style={{ fontSize: '13px' }}>Impostazioni</span>
              </a>
            </div>
            {user && (
              <button onClick={handleLogout} style={{ marginTop: '4px', padding: '12px 28px', borderRadius: '10px', backgroundColor: 'rgba(255,255,255,0.15)', border: '2px solid rgba(255,255,255,0.5)', color: '#ffffff', fontSize: '15px', fontWeight: 700, cursor: 'pointer', fontFamily: 'Roboto, sans-serif' }}>
                Esci
              </button>
            )}
          </nav>
        </div>
      )}
    </>
  );
}
